import React from "react";

export const Today = ({ variant = "time" }) => {
  const date = new Date();
  const hour = date.getHours();
  
  const timeOfDay = 
    (hour < 4 && "evening") ||
    (hour < 12 && "morning") ||
    (hour < 18 && "afternoon") ||
    "evening";

  return (
    <>
      {variant === "time" && `Great ${timeOfDay} to you`}
    </>
  );
};